module.exports = __webpack_public_path__ + "img/IMG_2671_FoamcoreMatted.766b9a07.jpg";